"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowSignableErrors__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  name: "CallerNotEndorser",
  type: "error"
}, {
  inputs: [],
  name: "InvalidEndorsement",
  type: "error"
}, {
  inputs: [],
  name: "InvalidSignature",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "endorsedBeneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "currentBeneficiary",
    type: "address"
  }],
  name: "MismatchedEndorsedBeneficiaryAndCurrentBeneficiary",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "endorsedNominee",
    type: "address"
  }, {
    internalType: "address",
    name: "onChainNominee",
    type: "address"
  }],
  name: "MismatchedEndorsedNomineeAndOnChainNominee",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "currentTimestamp",
    type: "uint256"
  }],
  name: "SignatureExpired",
  type: "error"
}];
class TitleEscrowSignableErrors__factory {
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TitleEscrowSignableErrors__factory = TitleEscrowSignableErrors__factory;
_defineProperty(TitleEscrowSignableErrors__factory, "abi", _abi);